export const ENGLISH = 'ENGLISH';
export const COMMON = 'COMMON';
export const TOTS = 'TOTS';

export const previewNameObj = {
  [ENGLISH]: '英语',
  [COMMON]: '普通',
  [TOTS]: '低幼',
};

export const previewEnNameObj = {
  [ENGLISH]: 'English',
  [COMMON]: 'Normal',
  [TOTS]: 'Tots',
};

export const PreviewUrlNameConfig = {
  contentUrl: '内容预览',
  nodeUrl: '单元预览',
  courseUrl: '课程预览',
};
